// TODO @consumer Move this as a global hook

import { useState } from 'react';

import useClickOutside from '../../../hooks/useClickOutside';

/**
 * React hook for expanding components.
 *
 * @param {MutableRefObject} [ref] The component ref.
 * @param {Object} [options] The options.
 * @param {boolean} [options.initialExpanded=false] Whether to start expanded.
 * @param {boolean} [options.ignoreModals] Whether to ignore clicks from modals.
 * @param {boolean} [options.collapseOnSelf=false] Whether to collapse on self clicks as well.
 * @returns {{expanded: boolean, toggleExpanded: toggleExpanded, setExpanded: React.Dispatch<React.SetStateAction<boolean>>}}
 */
const useExpanded = (
  ref,
  { initialExpanded = false, ignoreModals, collapseOnSelf = false } = {},
) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  useClickOutside(
    ref,
    () => {
      setExpanded(false);
    },
    ignoreModals,
  );

  if (collapseOnSelf) {
    // Collapse even when anything on the body of the element is clicked
    // (useful for dropdowns).
    ref?.current?.addEventListener('click', () => setExpanded(false));
  }

  return {
    expanded,
    setExpanded,
    toggleExpanded: () => {
      setExpanded(current => !current);
    },
  };
};

export default useExpanded;
